import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const API_URL = `${API_BASE_URL}/measures`;

const measureService = {
  listMeasures() {
    const token = authService.getToken();
    return axios.get(`${API_URL}/`, {
      headers: { Authorization: `Token ${token}` }
    });
  }
};

export default measureService;
